import { Menu } from "@headlessui/react";
import clsx from "clsx";
import React from "react";

type DropdownMenuItemsProps = {
    children: React.ReactNode;
    className?: string;
};

const DropdownMenuItems = React.forwardRef<
    HTMLDivElement,
    DropdownMenuItemsProps
>(({ children, className }, forwardedRef) => {
    return (
        <Menu.Items
            className={clsx(
                "absolute right-0 mt-2 rounded-xl bg-surface-light overflow-hidden z-30",
                className
            )}
            ref={forwardedRef}
            as="div"
            style={{
                boxShadow: "0px 2px 6px 2px rgba(0, 0, 0, 0.15)",
            }}
        >
            {children}
        </Menu.Items>
    );
});

export default DropdownMenuItems;
